<template>
    <div class="container">
        <div class="main__top">
            <h1 class="main__title wow fadeInDown" data-wow-duration="1.5s">users</h1>
        </div>
        <div class="profile">

            <ul class="nav nav-tabs justify-content-start" id="myTab" role="tablist">
                <li class="nav-item">
                    <a
                        class="nav-link"
                        :class="{ active: sortStatus === 'active' }"
                        role="tab"
                        @click="sortStatus = 'active'"
                    >
                        Active Users
                    </a>
                </li>
                <li class="nav-item">
                    <a
                        class="nav-link"
                        :class="{ active: sortStatus === 'inactive' }"
                        role="tab"
                        @click="sortStatus = 'inactive'"
                    >
                        Inactive Users
                    </a>
                </li>
                <li style="margin-left: auto;">
                    <a :href="`/admin/user/create`" class="btn btn_primary-outline">+ Add User</a>
                </li>
            </ul>

            <div class="tab-content p-0" id="myTabContent">
                <div
                    class="tab-pane fade show active"
                    id="first"
                    role="tabpanel"
                    v-if="sortedUsers"
                >
                    <form>
                        <div class="users">
                            <div class="users__table">
                                <ul class="users__list">
                                    <draggable v-model="sortedUsers" @end="onDragEnd">

                                        <li class="users__line"
                                            v-for="user in sortedUsers"
                                            :key="user.id"
                                        >
                                            <div class="users__move">
                                                <button type="button" class="move">Move Item</button>
                                            </div>
                                            <div class="users__photo">
                                                <a :href="`/admin/user/${user.id}/update`" class="photo">
                                                    <img :src="getNameOfAvatar(user.avatar)" alt="User Photo" width="60">
                                                </a>
                                            </div>
                                            <div class="users__name">
                                                <a
                                                    :href="`/admin/user/${user.id}/update`"
                                                    class="name"
                                                >
                                                    {{ user.first_name }} {{ user.last_name}}
                                                </a>
                                                <p>{{ user.type }}</p>
                                            </div>
                                            <div class="users__email">
                                                <a href="mailto:alex_123@gmail.com">{{ user.email }}</a>
                                            </div>
                                            <div class="users__status" v-if="user.isActive">
                                                <p class="status status_active">Active</p>
                                            </div>
                                            <div class="users__status" v-else>
                                                <p class="status status_inactive">Inactive</p>
                                            </div>
                                            <div class="">
                                                <div class="users__right">
                                                    <button type="button" class="users__more">
                                                        <svg width="16" height="16" class="icon">
                                                            <use href="/img/svg/symbol-defs.svg#icon-dots"></use>
                                                        </svg>
                                                    </button>
                                                    <div class="users__tool">
                                                        <a :href="`/admin/user/${user.id}/update`" class="users__action">
                                                            <svg width="16" height="16" class="icon">
                                                                <use href="/img/svg/symbol-defs.svg#icon-edit"></use>
                                                            </svg>
                                                            Edit
                                                        </a>
                                                        <button
                                                            type="button"
                                                            class="users__action"
                                                            @click="openDeleteModal(user.id)"
                                                        >
                                                            <svg width="16" height="16" class="icon">
                                                                <use href="/img/svg/symbol-defs.svg#icon-close-9"></use>
                                                            </svg>
                                                            Delete
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </li>
                                    </draggable>
                                </ul>
                            </div>
                        </div>
                        <ActionModal
                            :modal-id="getCustomModalId('delete',currentUserId)"
                            @confirm="deleteUser(currentUserId)"
                            :reject-text="`No`"
                            :confirm-text="`Yes`"
                        >
                            <template #body>
                                <div class="text-center mb-4">
                                    <div class="text-center">
                                        <h5 class="title">Are you sure ?</h5>
                                        <p>Do you want to delete this user?</p>
                                    </div>
                                </div>
                            </template>
                        </ActionModal>
                    </form>
                </div>
                <div class="tab-pane fade" id="second" v-else>
                    <div class="categories__empty">
                        <svg width="45" height="45">
                            <use href="/img/svg/symbol-defs.svg#icon-cinema"></use>
                        </svg>
                        <p>There are no users</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {defineComponent, nextTick} from 'vue'
import {mapActions, mapState} from "pinia";
import {useAdminStore} from "../../stores/AdminStore";
import AdminService from "../../services/AdminService";
import draggable from "vuedraggable";
import ActionModal from "../Common/ActionModal.vue";
import ModalHandler from "../../mixins/ModalHandler";

export default defineComponent({
    name: "ListOfUsers",
    components: {ActionModal, draggable},
    mixins: [ModalHandler],
    data () {
        return {
            currentUserId: null,
            sortStatus: 'active',
        }
    },
    computed: {
        ...mapState(useAdminStore, {
            listOfUsers: 'listOfUsers'
        }),
        sortedUsers: {
            get() {
                return this.sortStatus === 'active'
                    ? this.listOfUsers.activeUsers
                    : this.listOfUsers.inactiveUsers;
            },
            set(newValue) {
                if (this.sortStatus === 'active') {
                    this.listOfUsers.activeUsers = newValue;
                } else {
                    this.listOfUsers.inactiveUsers = newValue;
                }
            }
        }
    },
    methods: {
        ...mapActions(useAdminStore, {
            fetchListOfUsers: 'fetchListOfUsers'
        }),
        onDragEnd() {
            const newOrderUsers = this.sortedUsers.map((item) => item.id);
            this.sendPositionToBackend(newOrderUsers);
        },
        async sendPositionToBackend(newOrderUsers) {
            this.$showLoadingMessage()
            try {
                await AdminService.updateUsersOrder(newOrderUsers)
                this.$showSuccessMessage('The order was updated')
            } catch (e) {
                this.$showErrorMessage('The order was not updated')
            }
        },
        openDeleteModal(id) {
            this.currentUserId = id;
            nextTick(() => {
                this.showCustomModal('delete', id);
            });
        },
        async deleteUser(id) {
            try {
                await AdminService.deleteUser(id)
                this.$showSuccessMessage('The user was deleted')
            } catch (e) {
                console.log(e)
                this.$showErrorMessage('The user was not deleted')
            }
        },
        getNameOfAvatar(photo) {
            return photo ? `/uploads${photo.file_path}` : "/img/svg/avatar.svg";
        },

    },
    created() {
        this.fetchListOfUsers()
    }
})
</script>



<style scoped>

</style>
